module.exports = __webpack_public_path__ + "img/mysoft-logo.40e7b516.svg";